import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'msg',
  pure: true,
})
export class TranslationMessagesPipe implements PipeTransform {
  private readonly translationPrefix = 'msg.';
  private readonly exceptionTranslationPrefix = 'exception.';

  constructor(private translate: TranslateService) {}

  transform(value: any, args?: any): Observable<string> {
    if (!value) return of('');
    return this.translate
      .stream(this.translationPrefix + value, args)
      .pipe(
        map((translated) =>
          translated === this.translationPrefix + value ? value : translated
        )
      );
  }

  transformInstant(value: any, args?: any): string {
    const key = this.translationPrefix + value;
    const translated = this.translate.instant(key, args);
    return translated === key ? value : translated;
  }

  transformExceptionInstant(value: any, args?: any): string {
    const key = this.exceptionTranslationPrefix + value;
    const translated = this.translate.instant(key, args);
    return translated === key ? value : translated;
  }
}
